import { render, staticRenderFns } from "./AppNavigationFooter.vue?vue&type=template&id=dd48770c&scoped=true&"
import script from "./AppNavigationFooter.vue?vue&type=script&lang=js&"
export * from "./AppNavigationFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd48770c",
  null
  
)

/* custom blocks */
import block0 from "./AppNavigationFooter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
